import { call, put } from "redux-saga/effects";
import { notification } from "antd";

import { Creators as WagonActions } from "../ducks/wagon";
import {
  index as indexService,
  activate,
  inactivate,
} from "../../services/wagonService";

export function* indexWagon(action) {
  try {
    const { groupId, farmId } = action.payload;
    const {
      data: { results: page },
    } = yield call(indexService, { groupId, farmId, size: 1000 });
    yield put(WagonActions.indexSuccess(page?.content || page || []));
  } catch (error) {
    yield put(WagonActions.indexError(error));
  }
}

export function* inactivateWagon(action) {
  try {
    yield call(inactivate, action.payload);
  } catch (error) {
    notification.error({
      message: "Vagão não foi inativado. Contate o suporte",
    });
  }
  yield put(WagonActions.index(action.payload.groupId, action.payload.farmId));
}

export function* activateWagon(action) {
  try {
    yield call(activate, action.payload);
  } catch (error) {
    notification.error({
      message: "Vagão não foi ativado. Contate o suporte",
    });
  }
  yield put(WagonActions.index(action.payload.groupId, action.payload.farmId));
}
